import {
  initialState,
  Actions,
  State,
  GET_ONE_JUDICIAL,
  GET_ONE_JUDICIAL_SUCCESS,
  GET_ONE_JUDICIAL_ERROR,
  RESET_GET_ONE_JUDICIAL,
} from "../../types/judicial/getOne";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_ONE_JUDICIAL:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case GET_ONE_JUDICIAL_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case GET_ONE_JUDICIAL_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      };
    case RESET_GET_ONE_JUDICIAL:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};

export default reducers;
